import { FC } from "react"
import { useBattleScreen } from "@/hooks/useBattleScreen"
import { BattleScreenView } from "@/modals/constructor/battle/BattleScreenModal/ui"
import { useModal } from "@/modals/hooks"
import { Modal } from "@/ui/Modal"
import styles from "./BattleScreenModal.module.scss"

const modalType = "battleScreen"

export const BattleScreenModal: FC = () => {
  const { getModalParams } = useModal(modalType)
  const { battleId } = getModalParams(modalType)
  const view = useBattleScreen(battleId)

  return (
    <Modal.Fullscreen
      type={modalType}
      isCanClose={false}
      className={styles.raise}
    >
      <BattleScreenView {...view} />
    </Modal.Fullscreen>
  )
}
